export const CHECKOUT_URL = 'https://pay.hotmart.com/K106146698C';
export const PRICE = '$6.990 CLP';
export const BOOK_TITLE = 'La Biblia de las Fallas Típicas';
export const BOOK_SUBTITLE = 'Edición Audio & Video — El Atlas de Diagnóstico Rápido para Laboratorios de Electrónica Especializada';
export const BOOK_TAGLINE = 'Deja de adivinar. Empieza a solucionar. Multiplica tu rentabilidad.';
export const BOOK_AUDIENCE = 'Preparado exclusivamente para el Especialista en Audio y Video. Edición de Alto Rendimiento — Flujo de Trabajo Profesional.';
export const painPoints = [{
  icon: 'clock',
  title: 'Horas perdidas buscando la falla',
  description: 'Cuatro horas midiendo punto por punto para terminar cambiando un condensador de $300. El tiempo del laboratorio es lo único que no se recupera.'
}, {
  icon: 'return',
  title: 'Equipos devueltos sin reparar',
  description: 'Cada amplificador o televisor que sale por la puerta sin arreglar es un cliente que no vuelve y una recomendación que nunca vas a recibir.'
}, {
  icon: 'money',
  title: 'Plata botada en adivinar',
  description: 'Cambiar componentes "por si acaso" te cuesta repuestos, envíos y credibilidad. El diagnóstico a ciegas es el gasto más caro del rubro.'
}] as const;
export const features = ['Diagnóstico paso a paso: qué medir, en qué orden y qué valor deberías ver.', 'Fotografías de componentes en alta resolución para identificar daños reales.', 'Patrones de falla comunes en fuentes de poder, televisores y equipos de audio.', 'Atlas de síntomas → causa probable para llegar al punto exacto en minutos.', 'Flujo de trabajo profesional pensado para el laboratorio de audio y video.', 'Precauciones de seguridad en etapas de alto voltaje y descarga de capacitores.'];
export const includedItems = [{
  label: 'eBook completo en PDF',
  note: "Fallas reales documentadas"
}, {
  label: 'Edición Audio & Video',
  note: 'Enfocada en amplificadores, TV y fuentes conmutadas'
}, {
  label: 'Descarga inmediata',
  note: 'Acceso en tu correo apenas se aprueba el pago'
}, {
  label: 'Actualizaciones incluidas',
  note: 'Nuevas versiones sin costo adicional'
}];
export const testimonials = [{
  quote: 'Me salvó de devolver un televisor complejo el primer día de uso. Seguí la secuencia de medición de la fuente y encontré el opto en menos de 15 minutos.',
  name: 'Rodrigo Salas',
  role: 'Técnico electrónico · Laboratorio propio, Concepción',
  avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/731f4a72-c662-4cc2-b742-80c327781339.jpg'
}, {
  quote: 'Llevo 12 años en audio y aun así encontré patrones que no tenía identificados. El atlas de síntomas es lo que más ocupo día a día.',
  name: 'Marcelo Pinto',
  role: 'Servicio técnico de audio · Santiago',
  avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/731f4a72-c662-4cc2-b742-80c327781339.jpg'
}, {
  quote: 'Lo compré pensando que era otro PDF genérico. Son fallas reales, con fotos reales. Recuperé el valor en la primera reparación.',
  name: 'Iván Cárdenas',
  role: 'Técnico en fuentes conmutadas · Valdivia',
  avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/731f4a72-c662-4cc2-b742-80c327781339.jpg'
}];
export const faqs = [{
  question: '¿Es un libro físico?',
  answer: 'No. Es un PDF digital de descarga instantánea. Apenas confirmas el pago recibes el acceso en tu correo y puedes abrirlo en el celular, tablet o computador del laboratorio.'
}, {
  question: '¿Cómo pago?',
  answer: 'El pago es 100% seguro a través de Hotmart. Puedes pagar con tarjeta de débito, crédito o los medios disponibles en Chile. Nunca vemos ni almacenamos tus datos bancarios.'
}, {
  question: '¿Incluye actualizaciones?',
  answer: 'Sí. Cada nueva versión de la guía, con las fallas que se van sumando, te llega sin costo adicional a la misma dirección de correo con la que compraste.'
}, {
  question: '¿Sirve si recién estoy partiendo en electrónica?',
  answer: 'Sí. Cada diagnóstico está explicado paso a paso, indicando qué instrumento usar y qué valor deberías leer. Si sabes usar un multímetro, puedes seguir la guía.'
}, {
  question: '¿Cuánto demora la entrega?',
  answer: 'Es inmediata. La aprobación del pago en Hotmart libera la descarga al instante, generalmente en menos de un minuto.'
}];